export default __webpack_public_path__ + "static/media/p2p-hover.1c9e384b.webp";